import { Component, OnInit, ViewChild } from '@angular/core';
import { Subject, Subscription } from "rxjs";
import { DataTableDirective } from "angular-datatables";
import { UserDataStoreService } from "../services/user-data-store.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { TerminalViewModel } from "../models/terminal-view-model";
import { TerminalService } from "../services/terminal.service";
import { Router } from "@angular/router";
import { PermissionEnum } from '../services/guards/permissions';
import { ToastrService } from 'ngx-toastr';
import { AuthenticationService } from "../services/authentication.service";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { TerminalDTViewModel } from '../models/terminal-dt-view-model';
import { debounceTime, distinctUntilChanged } from "rxjs/operators";
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { DataTablesResponseViewModel } from '../models/data-tables-response-view-model';


@Component({
  selector: 'app-terminal-audit',
  templateUrl: './terminal-audit.component.html',
  styleUrls: ['./terminal-audit.component.scss']
})
export class TerminalAuditComponent implements OnInit {
  public dtTrigger: Subject<boolean> = new Subject();
  public terminals: TerminalDTViewModel[] = [];
  public searchDebounce = new Subject<string>();

  public canView: boolean = false;
  public canEdit: boolean = false;
  public canAdd: boolean = false;
  public ViewButtonStyle: string;

  @ViewChild(DataTableDirective)
  public dtElement: DataTableDirective;
  public terminalIdSearch = '';
  public nameSearch = '';
  public statusSearch = '';
  public merchantIdSearch = '';

  constructor(private _httpClient: HttpClient,
    private _router: Router,
    private _userDataStore: UserDataStoreService,
    private _authenticationService: AuthenticationService,
    private _modalService: NgbModal,
    private _terminalService: TerminalService,
    private _toastService: ToastrService,
    private _ngxUiLoaderService: NgxUiLoaderService) {


    this.canView = this._userDataStore.hasRequiredPermissions([PermissionEnum.ViewTerminalAudit], []);
    if (!this.canView) {
      this.ViewButtonStyle = "display: none";
      this._toastService.warning("You do not have the required permissions to view this page, Please contact your system administrator", "Warning");
      this._router.navigate(['/']);
      this._ngxUiLoaderService.stop();
      this.ngOnDestroy();
    }

    this.searchDebounce.pipe(
      debounceTime(800),
      distinctUntilChanged())
      .subscribe(async value => {
        await this.refreshTable();
      });

  }

  ngOnInit() {
    // this.dtOptions = {
    //   pagingType: 'full_numbers',
    //   pageLength: 10
    // };
  }

  public async ngAfterViewInit(): Promise<void> {
    this.dtTrigger.next();
    // await this.init();
  }

  private async init(): Promise<void> {
    this._ngxUiLoaderService.start();

    this.terminals = await this._terminalService.GetAllTerminals();

    this.dtTrigger.next();

    this._ngxUiLoaderService.stop();
  }

  private resetDatatable(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      // Destroy the table first
      dtInstance.destroy();
      // Call the dtTrigger to rerender again
      this.dtTrigger.next();
    });
  }

  private async refreshTable(): Promise<void> {
    await this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      // Destroy the table first
      dtInstance.destroy();
      this.setupFilters();
      // Call the dtTrigger to rerender again
      this.dtTrigger.next();
    });
  }

  public setupFilters(): void {
    const searchColumns = this.columns.map((col) => {
      if (!!(col).search) {
        return { search: (col).search.value, regex: (col).search.regex };
      } else {
        return null;
      }
    });
    //this.dtOptions.searchCols = searchColumns;
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      let i = 0;
      for (const item of searchColumns) {
        if (item) {
          dtInstance.column(i).search(item.search, item.regex);
        }
        i++;
      }
    })
  }

  public columns: any[] = [

    { data: 'id', title: 'Terminal Id', visible: true, searchable: true, search: { value: this.terminalIdSearch, regex: true } },
    { data: 'shortName', title: 'Name', visible: true, searchable: true, search: { value: this.nameSearch, regex: true } },
    { data: 'cardAcceptor', title: 'Merchant number', visible: true, searchable: true, search: { value: this.merchantIdSearch, regex: true } },
    { data: 'termActive', title: 'Active', visible: true, searchable: true, search: { value: this.statusSearch, regex: true } },
  ];

  private searchColumns = this.columns.map((col) => {
    if (!!col.search) {
      return { search: col.search.value, regex: col.search.regex };
    } else {
      return null;
    }
  });

  public dtOptions: DataTables.Settings = {
    pageLength: 10,
    serverSide: true,
    processing: true,
    ajax: (dataTablesParameters: any, callback) => {
      this._httpClient
        .post<DataTablesResponseViewModel>(
          `${environment.apiUrl}/api/terminal/Search`,
          dataTablesParameters, {}
      ).subscribe(resp => {
        this.terminals = resp.data;

          callback({
            recordsTotal: resp.recordsTotal,
            recordsFiltered: resp.recordsFiltered,
            data: []
          });
        });
    },
    columns: this.columns,
    searchCols: this.searchColumns

  };

  public get displayColumns() {
    return this.dtOptions.columns.filter(x => x.visible != false);
  }

  public async viewTerminal(terminal: TerminalViewModel): Promise<void> {
    this._router.navigate(['management', 'audit-terminal', terminal.id]);
  }


  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    this.dtTrigger.unsubscribe();
  }
}
